import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer


let service = new services();
export default {
    name: 'Buypoint',
    data () {
        return {
            child_route_view:false,
            loading:false,
            loggedIn:false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image:""
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
     },
    methods: {
        
        setSellpoint(){ 
            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    document.title = this.sellpoint.business_name + " | SP";
                
                //set the banner image 
                if((this.sellpoint.business_banner_image == this.default_banner_image) || (this.sellpoint.business_banner_image == 'error')){
                    //assign gw general banner image
                    this.set_gallery_banner_image = service.general_banner_image; 
                }else{
                    //use the sellpoints banner image
                    this.set_gallery_banner_image = this.sellpoint.business_banner_image;
                }
                    
                    //dummy settings
                    if(this.sellpoint.business_market_subscription_name == 'Bird Plan'){
                        this.max_plan_lookbooks = 2;
                        this.max_plan_lookbook_posts = 5;
                    }
                    if(this.sellpoint.business_market_subscription_name == 'Mid Bird Plan'){
                        this.max_plan_lookbooks = 10;
                        this.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if(this.sellpoint.business_market_subscription_name == 'Max Bird Plan'){
                        this.max_plan_lookbooks = 50;//unlimited
                        this.max_plan_lookbook_posts = 50;//unlimited
                        this.can_add_product_lookbook = true; //online shop functionality
                    }
                    
                    
                    this.preset();
                    this.loading = false;
                }else{
                    this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch((err) => {
                this.loading = false;
                //move
                //maybe no connection ..load from local
            // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },
    },

    created: function(){
        this.setSellpoint();
    },
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/script.js